// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  RoleBankPermission,
  RoleBankPermissionT,
  verifyRoleBankPermission,
} from "./role-bank-permission";
import {
  RoleFloorPermission,
  RoleFloorPermissionT,
  verifyRoleFloorPermission,
} from "./role-floor-permission";
import {
  RoleLiftPermission,
  RoleLiftPermissionT,
  verifyRoleLiftPermission,
} from "./role-lift-permission";
import { RoleMenu, RoleMenuT, verifyRoleMenu } from "./role-menu";
import { RoleOrgGrant, RoleOrgGrantT, verifyRoleOrgGrant } from "./role-org-grant";
import {
  RolePermissionGrant,
  RolePermissionGrantT,
  verifyRolePermissionGrant,
} from "./role-permission-grant";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * RBAC role with permission menu tree.
 */
export class Role implements flatbuffers.IUnpackableObject<RoleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Role {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRole(bb: flatbuffers.ByteBuffer, obj?: Role): Role {
    return (obj || new Role()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsRole(bb: flatbuffers.ByteBuffer, obj?: Role): Role {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Role()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  baseRoleId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  displayName(): string | null;
  displayName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  displayName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  /**
   * Structured permission menu tree.
   */
  menu(obj?: RoleMenu): RoleMenu | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new RoleMenu()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * JSON-encoded permission menu tree (legacy, kept for backward compat).
   */
  menuJson(): string | null;
  menuJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  menuJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * JSON-encoded permission overrides applied on top of `base_role`.
   */
  permissionOverridesJson(): string | null;
  permissionOverridesJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  permissionOverridesJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Per-bank scope grants for this role. Populated on role GET (the roles
   * API the permissions editor reads/writes). Empty vector = access to all
   * banks (default enforced by consumers). Appended at end of table for
   * `FlatBuffer` wire compatibility.
   */
  bankPermissions(index: number, obj?: RoleBankPermission): RoleBankPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new RoleBankPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Per-lift scope grants for this role. Empty vector = access to all lifts.
   */
  liftPermissions(index: number, obj?: RoleLiftPermission): RoleLiftPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset
      ? (obj || new RoleLiftPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Per-floor scope grants for this role. Empty vector = access to all floors.
   */
  floorPermissions(index: number, obj?: RoleFloorPermission): RoleFloorPermission | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new RoleFloorPermission()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  floorPermissionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Cross-org reachability grants for this role. Empty vector = the role
   * reaches only its OWN org subtree — the safe default, unlike the scope
   * vectors above where empty means "everything". Appended at end of table
   * for `FlatBuffer` wire compatibility.
   */
  orgGrants(index: number, obj?: RoleOrgGrant): RoleOrgGrant | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset
      ? (obj || new RoleOrgGrant()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  orgGrantsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * The role's explicit permission decisions, one entry per decided
   * catalogue key (LIFT-1090). This is what `LiftCloud` stores in
   * `roles.permission_grants`. When non-empty it is authoritative; when
   * empty, readers fall back to the `permission_grants` object embedded at
   * the root of `menu_json`, which is how writers that predate this field
   * carry the same decisions. Writers keep embedding them there too, so
   * older readers are unaffected. Appended at end of table for `FlatBuffer`
   * wire compatibility.
   */
  permissionGrants(index: number, obj?: RolePermissionGrant): RolePermissionGrant | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset
      ? (obj || new RolePermissionGrant()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  permissionGrantsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startRole(builder: flatbuffers.Builder) {
    builder.startObject(17);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, orgIdOffset, 0);
  }

  static addBaseRoleId(builder: flatbuffers.Builder, baseRoleIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, baseRoleIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addDisplayName(builder: flatbuffers.Builder, displayNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, displayNameOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(5, +active, +true);
  }

  static addMenu(builder: flatbuffers.Builder, menuOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, menuOffset, 0);
  }

  static addMenuJson(builder: flatbuffers.Builder, menuJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, menuJsonOffset, 0);
  }

  static addPermissionOverridesJson(
    builder: flatbuffers.Builder,
    permissionOverridesJsonOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(8, permissionOverridesJsonOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, deletedAtOffset, 0);
  }

  static addBankPermissions(
    builder: flatbuffers.Builder,
    bankPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(12, bankPermissionsOffset, 0);
  }

  static createBankPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addLiftPermissions(
    builder: flatbuffers.Builder,
    liftPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(13, liftPermissionsOffset, 0);
  }

  static createLiftPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addFloorPermissions(
    builder: flatbuffers.Builder,
    floorPermissionsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(14, floorPermissionsOffset, 0);
  }

  static createFloorPermissionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFloorPermissionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOrgGrants(builder: flatbuffers.Builder, orgGrantsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, orgGrantsOffset, 0);
  }

  static createOrgGrantsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOrgGrantsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPermissionGrants(
    builder: flatbuffers.Builder,
    permissionGrantsOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(16, permissionGrantsOffset, 0);
  }

  static createPermissionGrantsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startPermissionGrantsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endRole(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // org_id
    builder.requiredField(offset, 10); // name
    return offset;
  }

  unpack(): RoleT {
    return new RoleT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.baseRoleId() !== null ? this.baseRoleId()!.unpack() : null,
      this.name(),
      this.displayName(),
      this.active(),
      this.menu() !== null ? this.menu()!.unpack() : null,
      this.menuJson(),
      this.permissionOverridesJson(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
        this.bankPermissions.bind(this),
        this.bankPermissionsLength(),
      ),
      this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
        this.liftPermissions.bind(this),
        this.liftPermissionsLength(),
      ),
      this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
        this.floorPermissions.bind(this),
        this.floorPermissionsLength(),
      ),
      this.bb!.createObjList<RoleOrgGrant, RoleOrgGrantT>(
        this.orgGrants.bind(this),
        this.orgGrantsLength(),
      ),
      this.bb!.createObjList<RolePermissionGrant, RolePermissionGrantT>(
        this.permissionGrants.bind(this),
        this.permissionGrantsLength(),
      ),
    );
  }

  unpackTo(_o: RoleT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.baseRoleId = this.baseRoleId() !== null ? this.baseRoleId()!.unpack() : null;
    _o.name = this.name();
    _o.displayName = this.displayName();
    _o.active = this.active();
    _o.menu = this.menu() !== null ? this.menu()!.unpack() : null;
    _o.menuJson = this.menuJson();
    _o.permissionOverridesJson = this.permissionOverridesJson();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.bankPermissions = this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
      this.bankPermissions.bind(this),
      this.bankPermissionsLength(),
    );
    _o.liftPermissions = this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
      this.liftPermissions.bind(this),
      this.liftPermissionsLength(),
    );
    _o.floorPermissions = this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
      this.floorPermissions.bind(this),
      this.floorPermissionsLength(),
    );
    _o.orgGrants = this.bb!.createObjList<RoleOrgGrant, RoleOrgGrantT>(
      this.orgGrants.bind(this),
      this.orgGrantsLength(),
    );
    _o.permissionGrants = this.bb!.createObjList<RolePermissionGrant, RolePermissionGrantT>(
      this.permissionGrants.bind(this),
      this.permissionGrantsLength(),
    );
  }

  unpackFields(...fields: string[]): RoleT {
    const t = new RoleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("base_role_id")) {
      t.baseRoleId = this.baseRoleId() !== null ? this.baseRoleId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("display_name")) {
      t.displayName = this.displayName();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("menu")) {
      t.menu = this.menu() !== null ? this.menu()!.unpack() : null;
    }
    if (fieldSet.has("menu_json")) {
      t.menuJson = this.menuJson();
    }
    if (fieldSet.has("permission_overrides_json")) {
      t.permissionOverridesJson = this.permissionOverridesJson();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("bank_permissions")) {
      t.bankPermissions = this.bb!.createObjList<RoleBankPermission, RoleBankPermissionT>(
        this.bankPermissions.bind(this),
        this.bankPermissionsLength(),
      );
    }
    if (fieldSet.has("lift_permissions")) {
      t.liftPermissions = this.bb!.createObjList<RoleLiftPermission, RoleLiftPermissionT>(
        this.liftPermissions.bind(this),
        this.liftPermissionsLength(),
      );
    }
    if (fieldSet.has("floor_permissions")) {
      t.floorPermissions = this.bb!.createObjList<RoleFloorPermission, RoleFloorPermissionT>(
        this.floorPermissions.bind(this),
        this.floorPermissionsLength(),
      );
    }
    if (fieldSet.has("org_grants")) {
      t.orgGrants = this.bb!.createObjList<RoleOrgGrant, RoleOrgGrantT>(
        this.orgGrants.bind(this),
        this.orgGrantsLength(),
      );
    }
    if (fieldSet.has("permission_grants")) {
      t.permissionGrants = this.bb!.createObjList<RolePermissionGrant, RolePermissionGrantT>(
        this.permissionGrants.bind(this),
        this.permissionGrantsLength(),
      );
    }
    return t;
  }
}

export class RoleT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public orgId: UuidT | null = null,
    public baseRoleId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public displayName: string | Uint8Array | null = null,
    public active: boolean = true,
    public menu: RoleMenuT | null = null,
    public menuJson: string | Uint8Array | null = null,
    public permissionOverridesJson: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public bankPermissions: RoleBankPermissionT[] = [],
    public liftPermissions: RoleLiftPermissionT[] = [],
    public floorPermissions: RoleFloorPermissionT[] = [],
    public orgGrants: RoleOrgGrantT[] = [],
    public permissionGrants: RolePermissionGrantT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.orgId === null || this.orgId === undefined) {
      throw new Error('Required field "org_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const baseRoleId = this.baseRoleId !== null ? this.baseRoleId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const displayName = this.displayName !== null ? builder.createString(this.displayName!) : 0;
    const menu = this.menu !== null ? this.menu!.pack(builder) : 0;
    const menuJson = this.menuJson !== null ? builder.createString(this.menuJson!) : 0;
    const permissionOverridesJson =
      this.permissionOverridesJson !== null
        ? builder.createString(this.permissionOverridesJson!)
        : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const bankPermissions = Role.createBankPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.bankPermissions),
    );
    const liftPermissions = Role.createLiftPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.liftPermissions),
    );
    const floorPermissions = Role.createFloorPermissionsVector(
      builder,
      builder.createObjectOffsetList(this.floorPermissions),
    );
    const orgGrants = Role.createOrgGrantsVector(
      builder,
      builder.createObjectOffsetList(this.orgGrants),
    );
    const permissionGrants = Role.createPermissionGrantsVector(
      builder,
      builder.createObjectOffsetList(this.permissionGrants),
    );

    Role.startRole(builder);
    Role.addId(builder, id);
    Role.addOrgId(builder, orgId);
    Role.addBaseRoleId(builder, baseRoleId);
    Role.addName(builder, name);
    Role.addDisplayName(builder, displayName);
    Role.addActive(builder, this.active);
    Role.addMenu(builder, menu);
    Role.addMenuJson(builder, menuJson);
    Role.addPermissionOverridesJson(builder, permissionOverridesJson);
    Role.addCreatedAt(builder, createdAt);
    Role.addUpdatedAt(builder, updatedAt);
    Role.addDeletedAt(builder, deletedAt);
    Role.addBankPermissions(builder, bankPermissions);
    Role.addLiftPermissions(builder, liftPermissions);
    Role.addFloorPermissions(builder, floorPermissions);
    Role.addOrgGrants(builder, orgGrants);
    Role.addPermissionGrants(builder, permissionGrants);

    return Role.endRole(builder);
  }

  clone(): RoleT {
    const obj = new RoleT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.baseRoleId = this.baseRoleId !== null ? this.baseRoleId!.clone() : null;
    obj.name = this.name;
    obj.displayName = this.displayName;
    obj.active = this.active;
    obj.menu = this.menu !== null ? this.menu!.clone() : null;
    obj.menuJson = this.menuJson;
    obj.permissionOverridesJson = this.permissionOverridesJson;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.bankPermissions = this.bankPermissions.map((e) => e.clone());
    obj.liftPermissions = this.liftPermissions.map((e) => e.clone());
    obj.floorPermissions = this.floorPermissions.map((e) => e.clone());
    obj.orgGrants = this.orgGrants.map((e) => e.clone());
    obj.permissionGrants = this.permissionGrants.map((e) => e.clone());
    return obj;
  }

  equals(other: RoleT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.baseRoleId !== null && other.baseRoleId !== null) {
      if (!this.baseRoleId!.equals(other.baseRoleId!)) return false;
    } else if (this.baseRoleId !== other.baseRoleId) return false;
    if (this.name !== other.name) return false;
    if (this.displayName !== other.displayName) return false;
    if (this.active !== other.active) return false;
    if (this.menu !== null && other.menu !== null) {
      if (!this.menu!.equals(other.menu!)) return false;
    } else if (this.menu !== other.menu) return false;
    if (this.menuJson !== other.menuJson) return false;
    if (this.permissionOverridesJson !== other.permissionOverridesJson) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.bankPermissions.length !== other.bankPermissions.length) return false;
    for (let i = 0; i < this.bankPermissions.length; i++) {
      const a = this.bankPermissions[i];
      const b = other.bankPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.liftPermissions.length !== other.liftPermissions.length) return false;
    for (let i = 0; i < this.liftPermissions.length; i++) {
      const a = this.liftPermissions[i];
      const b = other.liftPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.floorPermissions.length !== other.floorPermissions.length) return false;
    for (let i = 0; i < this.floorPermissions.length; i++) {
      const a = this.floorPermissions[i];
      const b = other.floorPermissions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.orgGrants.length !== other.orgGrants.length) return false;
    for (let i = 0; i < this.orgGrants.length; i++) {
      const a = this.orgGrants[i];
      const b = other.orgGrants[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.permissionGrants.length !== other.permissionGrants.length) return false;
    for (let i = 0; i < this.permissionGrants.length; i++) {
      const a = this.permissionGrants[i];
      const b = other.permissionGrants[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyRole(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "org_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 16);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyRoleMenu(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleBankPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleLiftPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleFloorPermission);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRoleOrgGrant);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyRolePermissionGrant);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
